import { FC } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';

import { AiImageGenerationModal } from 'components/common/BannerImg/AiImageGenerationModal/AiImageGenerationModal';
import { CropImageModal } from 'components/common/BannerImg/CropImageModal/CropImageModal';
import { GalleryModal } from 'components/common/BannerImg/GalleryModal/GalleryModal';
import { useCpcFormData } from 'components/CpcFlexibleCreate/CpcForm/useCpcFormData';

import { useSelector } from 'store/utils';

export const CpcForm: FC = () => {
    const currentStep = useSelector((state) => state.createCampaign.currentStep);
    const { stepContent } = useCpcFormData();

    return (
        <div data-qa="ad-create-form">
            {stepContent[currentStep]}
            <VSpacing default={32} />
            <CropImageModal />
            <GalleryModal />
            <AiImageGenerationModal />
        </div>
    );
};
